import React, { Component } from 'react';
import { connect } from "react-redux";

const width=448;

function PlayTick(props) {
    let style = {
        left: 448 * props.currentStep / props.track.length,
    };

    return (
        <div className="play-tick" style={style}/>
    );
}

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.getSequenceId();
    let currentGlobalStep = state.sequencer.currentGlobalStep[id] || 0;
    let currentStep = props.track.getPatternStep(currentGlobalStep);

    return {
        currentStep: currentStep,
    };
};

export default connect(mapStateToProps, null)(PlayTick);
